import React from "react"
import "./styles.css"

export default function Main() {
    return (
        <main>
            <section className="first-part">
                <h1>Ableton</h1>
            </section>
            <section className="second-part">
                <p>
                    We make <span>Live</span>, <span>Push</span> and <span>Link</span> — unique software and hardware for music creation and performance. With these products, our community of users creates amazing things.
                </p>
                <p>
                    Ableton was founded in 1999 and released the first version of Live in 2001. Our products are used by a community of dedicated musicians, sound designers, and artists from across the world.
                </p>
            </section>
            <section className="third-part">
                <div className="yellow-square"></div>
                <div className="first-image"></div>
                <div className="second-image"></div>
            </section>
            <section className="fourth-part">
                <p>
                    Making music isn't easy. It takes time, effort, and learning. But when you're in the flow, it's incredibly rewarding.
                </p>
                <p>
                    We feel the same way about making Ableton products. The driving force behind Ableton is our passion for what we make, and the people we make it for.
                </p>
            </section>
            <section className="fifth-part">
                <figure>
                    <iframe width="660" height="371" src="https://www.youtube.com/embed/9SbnhgjeyXA" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe>
                    <figcaption>Why Ableton - Juanpe Bolivar</figcaption>
                </figure>
            </section>
            <section className="sixth-part">
                <p>
                    We are more than 350 people from 30 different countries divided between our headquarters in Berlin and our offices in Los Angeles and Tokyo.
                </p>
                <p>
                    Most of us are active musicians, producers, and DJs, and many of us use Live and Push every day. We come from a wide range of cultural and professional backgrounds. Some of us have PhDs, some are self-taught, and most of us are somewhere in between. What connects us is the shared belief that each of us has the skills and knowledge to contribute to something big: helping to shape the future of music culture.
                </p>
            </section>
            <section className="seventh-part">
                <div className="green-square"></div>
                <div className="container-double-image">
                    <div className="first-image"></div>
                    <div className="second-image"></div>
                </div>
                <div className="third-image"></div>
            </section>
            <section className="eight-part">
                <p>
                    We believe it takes focus to create truly outstanding instruments. We only work on a few products and we strive to make them great.
                </p>
                <p>
                    Rather than having a one-size-fits-all process, we try to give our people what they need to work their magic and grow. We've learned that achieving the best results comes from building teams that are richly diverse, and thus able to explore problems from a wider set of perspectives. We don't always agree with each other, but opinion and debate are valued and openly encouraged.
                </p>
            </section>
            <section className="nineth-part">
                <img src="https://ableton-production.imgix.net/about/poster-meet-the-makers.jpg?auto=format&dpr=2.0&fit=crop&fm=jpg&ixjsv=1.1.3&q=50&w=1160" />
            </section>
            <section className="tenth-part">
                <p>
                    We're passionate about what we do, but we're equally passionate about improving who we are.
                </p>
                <p>
                    We work hard to foster an environment where people can grow both personally and professionally, and we strive to create a wealth of opportunities to learn from and with each other.
                </p>
                <p>
                    Alongside an internal training program, employees are actively supported in acquiring new knowledge and skills, and coached on applying these in their daily work. In addition, staff-organized development and music salons are a chance to discuss new technologies, production techniques and best practices.
                </p>
            </section>
            <section className="eleventh-part">
                <div className="purple-square"></div>
                <div className="first-image"></div>
                <div className="second-image"></div>
            </section>
            <section className="twelveth-part">
                <p>
                    We want our employees to love it here. Since we're looking for exceptional talent from around the world, we will do everything we can to make your transition as easy as possible.
                </p>
                <p>
                    If you're joining us in Berlin, we'll help with relocation and paperwork. We'll even provide you with free German or English lessons. Plus, working in Germany means you can expect comprehensive health insurance for you and your family, as well as generous maternity and paternity leave. Office hours are flexible, but it's not all work; we have several company and team outings throughout the year as well as a variety of fun, informal small-group activities.
                </p>
            </section>
            <section className="thirdteenth-part">
                <div className="image"></div>
                <div className="blue-square">
                    <p>
                        We're really proud of the work we've done so far. But there's so much more to come. If you'd like to be a part of it, please join us.
                    </p>
                    <a href="#">See lastest jobs<i class='bx bx-chevron-right'></i></a>
                </div>
            </section>
        </main>
    )
}